<template>
    <div id="ig-page-user-list">
        <AppBreadCrumb :paths="[{ title: $t('ig.instagram') }]" :select="true">
            <a-button
                class="actionButtonBreadcrumb"
                @click="unsubscribe"
                type="danger"
                v-if="initialized && status.purchased"
            >
                {{ $t("wp.unsubscribe") }}
            </a-button>
        </AppBreadCrumb>
        <div style="background-color: #ffffff" class="d-flex">
            <div class="side-menubar-wrapper" style="width: 15%">
                <InstagramMenu selected-page="contact-list" />
            </div>
            <div class="main-content" style="width: 85%">
                <ActivateInstagramAlert v-if="!instagramPlanExists" />
                <div>
                    <h3 class="title">{{ $t("message.instagramContactList") }}</h3>
                    <div class="selection-bar" v-if="selections.length">
                        <section class="uncheck" @click="unselectAll">
                            <span class="material-icons"> arrow_back </span>
                            {{ $t("chatbotv2.uncheckAll") }}
                        </section>
                        <section class="select" @click="selectAll">{{ $t("chatbotv2.selectAll") }}</section>
                        <section class="queries">+{{ selections.length }} contact selected</section>
                        <section class="actions">
                            <!--                            <a-popover-->
                            <!--                                :visible="createCustomerGroupFormVisible"-->
                            <!--                                :overlayClassName="'no-padding'"-->
                            <!--                                placement="bottom"-->
                            <!--                                @visibleChange="changeCreateGroupPopupVisible"-->
                            <!--                                trigger="click"-->
                            <!--                            >-->
                            <!--                                <div slot="content">-->
                            <!--                                    <CreateCustomerGroupWithNumbers-->
                            <!--                                        :contacts="getSelectedContacts()"-->
                            <!--                                        :on-cancelled="() => changeCreateGroupPopupVisible(false)"-->
                            <!--                                        :on-completed="() => changeCreateGroupPopupVisible(false, true)"-->
                            <!--                                    />-->
                            <!--                                </div>-->

                            <!--                                <a-button-->
                            <!--                                    ghost-->
                            <!--                                    v-tippy="{ followCursor: true, placement: 'bottom-end' }"-->
                            <!--                                    :content="$t('wp.createCustomerGroup')"-->
                            <!--                                    >{{ $t("wp.createCustomerGroup") }}-->
                            <!--                                </a-button>-->
                            <!--                            </a-popover>-->

                            <a-button ghost class="d-none">{{ $t("wp.sendBroadcastMessage") }}</a-button>
                        </section>
                    </div>
                    <div class="my-1" style="width: 300px !important; margin: 0px 5px !important">
                        <a-input-search
                            v-model="searchText"
                            @input="onSearch($event.target.value)"
                            :placeholder="$t('message.search')"
                            class="row search-input"
                        />
                    </div>
                    <div>
                        <a-table
                            :columns="cols"
                            :dataSource="getValidContacts"
                            :pagination="pagination"
                            :loading="loading"
                            @change="handleTableChange"
                            :key="'vtable-' + renderCount"
                            :locale="{
                                emptyText: $t('message.noContactFound'),
                            }"
                            rowKey="id"
                            size="small"
                            class="custom-table"
                            :row-selection="{ onChange: rowSelectionOnChange, selectedRowKeys: selections }"
                        >
                            <div></div>
                            <div slot="avatarSlot" slot-scope="data, item" class="p-1">
                                <a-avatar
                                    :size="30"
                                    shape="square"
                                    style="background-color: #3899ff; border-radius: 7px !important"
                                    :username="item.full_name"
                                    :src="getAvatarUrl(item)"
                                >
                                    {{ $_.get(item, "full_name", "").substr(0, 1).toLocaleUpperCase() }}
                                </a-avatar>
                            </div>
                            <div slot="id" slot-scope="data, item" class="p-1">
                                {{ item.id.slice(0, -5) }}
                            </div>
                            <div slot="name" slot-scope="data, item" class="p-1">
                                {{ item.full_name || item.username }}
                            </div>
                            <div slot="isFollower" slot-scope="data, item" class="p-1">
                                {{ item.isFollower ? "Follower" : "Following" }}
                            </div>
                            <div slot="action" slot-scope="data, item">
                                <div class="d-flex justify-content-end" style="margin-right: -10px !important">
                                    <md-button
                                        class="igStartChat"
                                        v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                            theme: isDarkMode ? 'light-border' : 'google',
                                        }"
                                        :content="$t('wp.startChatWp')"
                                        data-v-step="16"
                                        @click="startChat(item.pk_id)"
                                    >
                                        {{ $t("wp.startChatWp") }}
                                        <div style="width: 30px; height: 30px">
                                            <InstagramIcon :width="30" :height="30" />
                                        </div>
                                    </md-button>
                                </div>
                            </div>
                        </a-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { log2 } from "../../../../../../utils/log2";
import { tableSorter } from "../../../../../../utils/utils";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { sendSocketMessage } from "../../../../../../utils/socketStream";
import Fuse from "fuse.js";
import "../../instagram.scss";
import { updateIntegration } from "../../../../../../api/billing";
import AppBreadCrumb from "../../../../../../components/common/AppBreadCrumb";
import _ from "lodash";
import ActivateInstagramAlert from "../../components/ActivateInstagramAlert";
import InstagramMenu from "../../components/InstagramMenu";
import InstagramIcon from "../../../../../../components/svg/InstagramIcon";
import ChatWatcher from "../../../../../../ChatWatcher";

const log = log2("InstagramUserList");

export default {
    name: "InstagramUserList",
    components: { InstagramMenu, AppBreadCrumb, ActivateInstagramAlert, InstagramIcon },
    props: {
        text: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            createCustomerGroupFormVisible: false,
            lastPersonelContacts: [],
            searchText: "",
            renderCount: 0,
            currentSort: {
                columnKey: "connectionTime",
                order: "ascend",
            },
            pagination: {
                defaultPageSize: 50,
                hideOnSinglePage: true,
                pageSizeOptions: ["10", "15", "20", "50", "100"],
                showQuickJumper: true,
                showSizeChanger: true,
            },
            cols: [
                {
                    key: "profile_pic_url",
                    dataIndex: "profile_pic_url",
                    title: this.$t("message.profile"),
                    ...tableSorter("profile_pic_url", "string", this.currentSort),
                    scopedSlots: { customRender: "avatarSlot" },
                },
                {
                    key: "full_name",
                    dataIndex: "full_name",
                    title: this.$t("message.name"),
                    ...tableSorter("full_name", "string", this.currentSort),
                    scopedSlots: { customRender: "name" },
                },
                {
                    key: "username",
                    dataIndex: `username`,
                    title: "Username",
                    ...tableSorter("username", "string", this.currentSort),
                    scopedSlots: { customRender: "username" },
                },
                {
                    key: "isFollower",
                    dataIndex: `isFollower`,
                    title: "Type",
                    ...tableSorter("isFollower", "string", this.currentSort),
                    scopedSlots: { customRender: "isFollower" },
                },
                {
                    title: "Action",
                    key: "operation",
                    scopedSlots: { customRender: "action" },
                    width: "100px",
                },
            ],
            loading: true,
            selections: [],
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            siteId: (state) => state.site.site._id,
            user: (state) => state.auth.user,
            contacts: (state) => state.instagram.contacts,
            status: (state) => state.instagram.info.status,
            initialized: (state) => state.instagram.info.initialized,
            instagramPlanExists: (state) => !!_.get(state.setting.settings, "instagram.plan"),
        }),
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
            isHealthy: "instagram/isHealthy",
            myActiveConversations: "chat/getMyActiveConversations",
        }),
        contactList() {
            let validContacts = this.contacts;
            const validContactsMap = validContacts.reduce((acc, cur) => {
                acc[cur.pk_id] = cur;
                return acc;
            }, {});
            return {
                array: validContacts,
                map: validContactsMap,
            };
        },
        getValidContacts() {
            if (!!this.contacts) {
                setTimeout(() => {
                    this.loading = false;
                }, 500);
                let validContacts = this.contacts;
                this.lastPersonelContacts = validContacts;
                this.lastPersonelContacts = this.getFilteredRows(this.lastPersonelContacts);
                return this.lastPersonelContacts;
            } else {
                this.loading = false;
                return [];
            }
        },
    },
    mounted() {
        log("mounted");
        sendSocketMessage("instagram get-users", { siteId: this.site._id });
    },
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
        }),
        ...mapMutations({
            changePurchaseStatus: "instagram/changePurchaseStatus",
        }),
        getAvatarUrl(item) {
            return item.v2Format && item.cdnUrl
                ? item.cdnUrl
                : `https://static.supsis.live/${this.siteId}/instagram/avatar/${item.pk_id}.jpg`;
        },
        async unsubscribe() {
            const self = this;
            this.$confirm({
                title: this.$t("wp.cancelIGIntegration"),
                content: this.$t("wp.terminatelIGIntegration"),
                okText: this.$t("wp.unsubscribeIGIntegration"),
                okType: "danger",
                cancelText: this.$t("wp.wpBack"),
                width: 600,
                height: 600,
                async onOk() {
                    await updateIntegration(self.siteId, "instagram", false);
                    self.getSettings();
                    sendSocketMessage("user settings-updated", {
                        siteId: self.siteId,
                    });
                    self.showWizard = false;
                    localStorage.removeItem("ig-agreement-accepted");
                    self.changePurchaseStatus(false);
                    sendSocketMessage("instagram unsubscribe", {
                        siteId: self.siteId,
                    });
                },
                onCancel() {},
            });
        },
        changeCreateGroupPopupVisible(visible, unselectMode = false) {
            this.createCustomerGroupFormVisible = visible;
            if (unselectMode) {
                this.selections = [];
            }
        },
        selectAll() {
            this.selections = this.getValidContacts.map((x) => x.id);
            this.renderCount++;
        },
        unselectAll() {
            this.selections = [];
            this.renderCount++;
        },
        getSelectedContacts() {
            const { map, array } = this.contactList;
            const selectedContacts = this.selections
                .map((x) => map[x])
                .map((x) => ({
                    number: x.id,
                    attributes: {
                        name: x.name,
                    },
                }));
            log("getSelectedContacts", { selectedContacts, selections: this.selections });
            return selectedContacts;
        },
        rowSelectionOnChange(selectedRowKeys, selectedRows) {
            this.selections = selectedRowKeys;
            log("rowSelectionOnChange", { selections: this.selections });
            this.renderCount++;
        },
        startChat(instagramUserId) {
            log("startChat", { instagramUserId });
            ChatWatcher.startChatImmediately({
                instagramUserId: instagramUserId,
            });
        },
        refresh() {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 500);
            sendSocketMessage("instagram get-users", { siteId: this.site._id });
            this.pagination.current = 1;
        },
        handleTableChange(pagination, filters, sorter) {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 370);
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
        },
        getFilteredRows(getContacts = this.contacts) {
            log("=this.contacts", getContacts);
            //if (getContacts.length === 0) getContacts = this.tempContacts; // if there is not integrated number use this. with a list
            let fuzzySearch = new Fuse(getContacts, { keys: ["username", "full_name"] });
            const filteredRows =
                this.searchText.length > 0 ? fuzzySearch.search(this.searchText).map((x) => x.item) : getContacts;
            log("filteredRow", filteredRows);
            return filteredRows;
        },
        onSearch(value) {
            log("onSearch", value);
            this.searchText = value;
            this.refresh();
        },
    },
};
</script>
<style lang="scss">
#ig-page-user-list {
    .ant-table-row {
        border-bottom: 1px solid lightgrey;
    }

    .ant-table table {
        border-collapse: collapse !important;
    }

    .ant-table-small {
        border: none !important;
    }

    .ant-table-body > table > .ant-table-tbody > tr > td {
        border: none !important;
    }

    .ant-table-body > table {
        border-right: none !important;
        border-left: none !important;
        line-height: 10px !important;
    }

    .ant-table-body > table > .ant-table-thead > tr > th {
        border: none !important;
    }

    .ant-table-small {
        .ant-table-tbody {
            td {
                padding: 2px 2px !important;
                height: 10px !important;
            }

            .ant-table-row {
                height: 10px !important;
            }
        }
    }

    .selection-bar {
        align-items: center;
        background: #006cff;
        color: #fff;
        display: flex;
        flex-wrap: wrap;
        height: 50px;
        left: 0;
        padding: 10px 30px;
        position: static;
        right: 0;

        section.uncheck {
            align-items: center;
            cursor: pointer;
            display: flex;
            grid-area: uncheck;
            transition: all 0.3s;

            &:hover {
                opacity: 0.8 !important;
            }

            .material-icons {
                font-size: 15px;
                margin-right: 10px;
                margin-top: 2px;
            }
        }

        section.select {
            cursor: pointer;
            grid-area: select;
            margin-left: 20px;
            transition: all 0.3s;

            &:hover {
                opacity: 0.8 !important;
            }
        }

        section.queries {
            grid-area: queries;
            margin-left: auto;
        }

        section.actions {
            align-items: center;
            display: flex;
            grid-area: actions;
            justify-content: center;
            margin-left: 20px;
            gap: 5px;

            div {
                align-items: center;
                border: 1px solid #fff;
                border-radius: 100%;
                cursor: pointer;
                display: flex;
                height: 26px;
                justify-content: center;
                margin: 0 5px;
                transition: opacity 0.3s;
                width: 26px;

                .material-icons {
                    color: #fff;
                    font-size: 15px;
                }
            }
        }
    }
}

.igStartChat {
    .md-button-content {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: row-reverse;
        gap: 5px;
        background: #f4f6f9;
        padding: 15px;
        border-radius: 10px;
    }
}
</style>
